<template>
  <div>
    <el-dialog
      title="发送确认"
      width="706px"
      :visible.sync="viewVisible"
      :before-close="handleClose"
    >
      <div class="message-list">
        <div class="message-item">
          <div class="label" style="line-height: 32px">选择咚咚群组：</div>
          <div class="value">
            <div class="label-list">
              <div class="label-item" v-for="(item, index) in infoObj.groupData" :key="index">
                {{item.groupName}}
              </div>
            </div>
          </div>
        </div>
        <div class="message-item">
          <div class="label">消息内容：</div>
          <div class="value">{{infoObj.messageType == '1' ? '商品卡片': '图文消息'}}</div>
        </div>
        <div class="message-item">
          <div class="label">发送时间：</div>
          <div class="value">
            {{infoObj.sendType === 1 ? '定时发送': '立即发送'}}<span class="time" v-if="infoObj.sendType === 1">{{infoObj.sendTime}}</span>
          </div>
        </div>
        <div class="tip-box">
          <img src="@/assets/images/new_icon_reminder.png" alt="" />
          <span>注：提交发送后无法撤回，请仔细核对咚咚群发内容哦！</span>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="handleConfim">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "group-send",
  data() {
    return {
      // visible: true,
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    infoObj: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    viewVisible: {
      get: function() {
        return this.visible;
      },
      set: function(nVal) {
        if (nVal) {
          this.$emit('update:visible', true)
        } else {
          this.$emit('update:visible', false)
        }
      }
    }
  },
  methods: {
    handleClose() {
      this.viewVisible = false;
    },
    handleConfim() {
      this.$emit('on-confirm')
    }
  },

};
</script>
<style lang="scss" scoped>
.message-list {
  font-size: 14px;
  color: #333;
  .message-item {
    margin-bottom: 20px;
    &:nth-child(1) {
      margin-bottom: 10px;
    }
    .label {
      display: inline-block;
      vertical-align: text-top;
      width: 98px;
      text-align: right;
    }
    .value {
      width: calc(100% - 98px);
      display: inline-block;
      vertical-align: text-top;
      .label-list {
        .label-item {
          display: inline-block;
          vertical-align: text-bottom;
          width: 210px;
          height: 32px;
          padding: 0 22px;
          line-height: 32px;
          text-align: center;
          font-size: 14px;
          color: #999;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          border: 1px solid #cccccc;
          margin-right: 12px;
          margin-bottom: 10px;
          &:nth-child(5n) {
            // margin-right: 0;
          }
        }
      }
      .time {
        margin-left: 10px;
        color: #7f85e9;
      }
    }
  }
  .tip-box {
    background: #fafafa;
    margin-left: 28px;
    color: #333;
    border-radius: 3px;
    height: 48px;
    line-height: 48px;
    padding-left: 12px;
    margin-bottom: 20px;
    span {
      vertical-align: middle;
    }
    img {
      width: 14px;
      height: 14px;
      vertical-align: middle;
      margin-right: 8px;
    }
    .url {
      color: #7f85e9;
    }
    .el-button {
      margin-left: 20px;
      height: 28px;
      width: 76px;
      box-sizing: border-box;
    }
  }
}
/deep/.el-dialog .el-dialog__header {
  line-height: 54px;
  height: 54px;
  padding-left: 30px;
}
/deep/.el-dialog__body {
  padding: 20px 30px 0 30px;
}
/deep/.el-dialog__footer {
  // border-top: 1px solid #f6f6f6;
  padding-bottom: 20px;
  padding-right: 30px;
  .dialog-footer{
    text-align: right;
  }
}
</style>